import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { 
  CoreTypes, 
  AppService, 
  CoreProxyService, 
  FormParametersComponent, 
  LabelValue,
  IMultiSelectOption,
  IMultiSelectTexts,
  IMultiSelectSettings
} from 'common-cloudstudio';

import { GearAppService } from 'common-gear';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';
import { ApolusProxyService, ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit, OnDestroy {
  
  @ViewChild('reportParameters') _parameters: FormParametersComponent;
  @ViewChild('reportResultContainer') reportResultContainer: ElementRef;
  @ViewChild('myForm') myForm: NgForm;

  _reportDefinition: any;
  _reportDetails: CoreTypes.ReportPageContent;
  _FilteredArray: CoreTypes.ReportPageContent;
  _params: Array<CoreTypes.FormParameter> = [];
  _currentPageNumber: number = 0;
  _totalPageCount: number = 0;
  _totalRowCount: string = '0';
  _rowsNumber: number = 25;
  _reportHandle: string = '';
  _facilityID: number;
  
  _filterValuesList: string[] = [];
  _filterValues: string[] = [];
  _cloneFilteredArray: CoreTypes.ReportPageContent;
  enableCleanFilter: boolean = false;
  cloneParams: Array<CoreTypes.FormParameter> = [];
  
  _NextHidden: boolean = false;
  _PreviousHidden: boolean = false;
  
  _subscriptions: Subscription[] = [];
  
  _firstTimeExecuted: boolean = false;
  _destroyed: boolean = false;
  
  jumpToPage: number;
  maxVisiblePages: number = 5;
  _itemsPerPageOptions: number[] = [10, 25, 50, 100];

  selectedRowIds: Set<string> = new Set<string>();
  currentPageRowIds: string[] = []; 
  allSelected: boolean = false;
  menuButtonList: LabelValue<number>[] = [
    { label: this._appService.CoreCommonLiterals.MultiSelect_All_Male, value: 1 },
    { label: this._appService.CoreCommonLiterals.None_Male, value: 2 },
  ];
  searchText: string = '';
  sectorList: LabelValue<number>[] = [];
  sector: LabelValue<number> = null;
  localityList: LabelValue<number>[] = [];
  locality: LabelValue<number> = null;
  addressList: LabelValue<number>[] = [];
  address: LabelValue<number> = null;
  streetNumberList: LabelValue<string>[] = [];
  streetNumber: LabelValue<string> = null;
  showAdvancedFilters: boolean = false;
  _selectedDeviceData: number[] = [];
  _deviceDataList: Array<IMultiSelectOption> = [
    { id: 1, name: 'N° de Serie' },
    { id: 2, name: 'Marca' },
    { id: 3, name: 'Modelo' },
    { id: 4, name: 'Fecha de Instalación' }
  ];
  _readingData: number[] = [];
  _readingDataList: Array<IMultiSelectOption> = [
    { id: 1, name: 'Consumo al corte' },
    { id: 2, name: 'Lectura actual' },
    { id: 3, name: 'Acumulado del mes en curso' },
    { id: 4, name: 'Promedio diario' }
  ];
  _valveData: number[] = [];
  _valveDataList: Array<IMultiSelectOption> = [
    { id: 1, name: 'Estado de la vávula' },
  ];
  _alertData: number[] = [];
  _alertDataList: Array<IMultiSelectOption> = [
    { id: 1, name: 'Alertas activas' },
  ];
  _multiSelectTexts: IMultiSelectTexts;
  _multiSelectSettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
  };
  _parameter: CoreTypes.FormParameter = {
    ...new CoreTypes.FormParameter(),
    ParameterID: 1,
    UniqueParameterID: 'dateFrom',
    Prompt: this._appService.CoreCommonLiterals.Period,
    ParameterType: CoreTypes.FormParameterType.DateTimeRange,
    ValueDateStartExpression: 'now/d',
    ValueDateEndExpression: 'now-13d/d'
  };

  constructor(
    public _appService: AppService,
    private _coreProxyService: CoreProxyService,
    public gearAppService: GearAppService,
    public apolusService: ApolusService,
    public apolusProxyService: ApolusProxyService
  ) {}

  ngOnInit(): void {
    this._facilityID = +this._appService.getFacilityID();
    this.initializeReport();
    this.getSectorsList().subscribe();
    this.getAddressesList().subscribe();
  }

  ngOnDestroy(): void {
    this._destroyed = true;
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  initializeReport(): void {
    this._reportDefinition = {
      ReportID: 1,
      Title: 'Reporte Apolus',
      ReportType: CoreTypes.ReportType.Tabular,
      Columns: [
        {
          "Alignment": 0,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "ID de Cliente",
          "WidthPixels": 160
        },
        {
          "Alignment": 0,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "N° de Contrato",
          "WidthPixels": 160
        },
        {
          "Alignment": 0,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "Nombre",
          "WidthPixels": 250
        },
        {
          "Alignment": 2,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "Domicilio",
          "WidthPixels": 70
        },
        {
          "Alignment": 2,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "Consumo",
          "WidthPixels": 180
        },
        {
          "Alignment": 2,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "Corte",
          "WidthPixels": 180
        },
        {
          "Alignment": 2,
          "IsHtml": false,
          "IsOrderable": false,
          "Title": "Tarifa",
          "WidthPixels": 120
        }
      ],
      Parameters: [
        {
          "AllowedValues": null,
          "Hidden": false,
          "Mandatory": true,
          "MultiSelectLiterals": null,
          "ParameterID": 3,
          "ParameterType": 1,
          "Prompt": "",
          "RefreshOnChange": false,
          "UniqueParameterID": null,
          "ValueCheck": false,
          "ValueDateEnd": null,
          "ValueDateEndExpression": null,
          "ValueDateStart": null,
          "ValueDateStartExpression": null,
          "ValueMultiString": null,
          "ValueNumber": 44300,
          "ValueString": null
        },
        {
          "AllowedValues": [
            {
              "Name": "Sector 1A",
              "Value": "356412"
            },
            {
              "Name": "SRS2 - Light sensor",
              "Value": "356418"
            },
            {
              "Name": "SRS3 - Light sensor",
              "Value": "356424"
            },
            {
              "Name": "SRS4 - Light sensor",
              "Value": "356430"
            },
            {
              "Name": "SRS5 - Light sensor",
              "Value": "356436"
            },
            {
              "Name": "Airco-lora1 - Light sensor",
              "Value": "356457"
            },
            {
              "Name": "Airco-lora2 - Light sensor",
              "Value": "356461"
            },
            {
              "Name": "Airco-lora3 - Light sensor",
              "Value": "356465"
            }
          ],
          "Hidden": false,
          "Mandatory": true,
          "MultiSelectLiterals": null,
          "ParameterID": 3,
          "ParameterType": 2,
          "Prompt": "",
          "RefreshOnChange": false,
          "UniqueParameterID": null,
          "ValueCheck": false,
          "ValueDateEnd": null,
          "ValueDateEndExpression": null,
          "ValueDateStart": null,
          "ValueDateStartExpression": null,
          "ValueMultiString": null,
          "ValueNumber": 0,
          "ValueString": "356412"
        },
        {
          "AllowedValues": [
            {
              "Name": "La Federacha",
              "Value": "356412"
            },
            {
              "Name": "SRS2 - Light sensor",
              "Value": "356418"
            },
            {
              "Name": "SRS3 - Light sensor",
              "Value": "356424"
            },
          ],
          "Hidden": false,
          "Mandatory": true,
          "MultiSelectLiterals": null,
          "ParameterID": 3,
          "ParameterType": 2,
          "Prompt": "",
          "RefreshOnChange": false,
          "UniqueParameterID": null,
          "ValueCheck": false,
          "ValueDateEnd": null,
          "ValueDateEndExpression": null,
          "ValueDateStart": null,
          "ValueDateStartExpression": null,
          "ValueMultiString": null,
          "ValueNumber": 0,
          "ValueString": "356412"
        },
        {
          "AllowedValues": [
            {
              "Name": "Los Alpes",
              "Value": "356412"
            },
            {
              "Name": "SRS2 - Light sensor",
              "Value": "356418"
            },
            {
              "Name": "SRS3 - Light sensor",
              "Value": "356424"
            },
          ],
          "Hidden": false,
          "Mandatory": true,
          "MultiSelectLiterals": null,
          "ParameterID": 3,
          "ParameterType": 2,
          "Prompt": "",
          "RefreshOnChange": false,
          "UniqueParameterID": null,
          "ValueCheck": false,
          "ValueDateEnd": null,
          "ValueDateEndExpression": null,
          "ValueDateStart": null,
          "ValueDateStartExpression": null,
          "ValueMultiString": null,
          "ValueNumber": 0,
          "ValueString": "356412"
        },
        {
          "AllowedValues": [
            {
              "Name": "2760",
              "Value": "356412"
            },
            {
              "Name": "SRS2 - Light sensor",
              "Value": "356418"
            },
            {
              "Name": "SRS3 - Light sensor",
              "Value": "356424"
            },
          ],
          "Hidden": false,
          "Mandatory": true,
          "MultiSelectLiterals": null,
          "ParameterID": 3,
          "ParameterType": 2,
          "Prompt": "",
          "RefreshOnChange": false,
          "UniqueParameterID": null,
          "ValueCheck": false,
          "ValueDateEnd": null,
          "ValueDateEndExpression": null,
          "ValueDateStart": null,
          "ValueDateStartExpression": null,
          "ValueMultiString": null,
          "ValueNumber": 0,
          "ValueString": "356412"
        }
      ],
      ExportFormats: [CoreTypes.ReportFileType.CSV, CoreTypes.ReportFileType.PDF],
      AutoRun: false,
      Selected: true,
      DynamicColumns: false,
      Enabled: true,
      ShowStar: false,
      Visible: true,
    };
    
    this._params = this._reportDefinition.Parameters;
    this.enableCleanFilter = false;
    this._filterValuesList = [];
    
    this._FilteredArray = { 
      Rows: [
        ['102030670', '102030670', 'Jose Luis Perez', 'Alpes 2760 int 6', '1203.00 lt', '23-09-2023', 'Residencial A'],
        ['102030630', '102030630', 'Maria Gomez', 'Alpes 2760 int 6', '1408.00 lt', '25-09-2024', 'Residencial A'],
      ], 
      RowCount: 2 
    };
    
    this._cloneFilteredArray = JSON.parse(JSON.stringify(this._FilteredArray));
    this._currentPageNumber = 1;
    this._totalPageCount = Math.max(1, Math.ceil(this._FilteredArray.RowCount / this._rowsNumber));
    this._totalRowCount = this._FilteredArray.RowCount.toString();
    
    this.updateCurrentPageIds();
  }

  emitChangeParam(param?: CoreTypes.FormParameter): void {
    const hasChanges = JSON.stringify(this.cloneParams) !== JSON.stringify(this._params);
    this.enableCleanFilter = hasChanges;
  }

  execReport(myForm: NgForm, downloadEvent?: any): void {
    this.myForm = myForm;
    
    const hasEmptyRequiredParams = this._params.some(p => 
      p.ParameterType === CoreTypes.FormParameterType.StringList && 
      !p.AllowedValues?.length && 
      (!p.ValueString || p.ValueString === '')
    );
    
    if (hasEmptyRequiredParams) {
      this._appService.showException('Por favor complete todos los campos obligatorios');
      return;
    }

    this._appService.startLoading();
    let filterValues: string[] = [];
    if (this._reportDefinition.ReportType === CoreTypes.ReportType.Tabular) {
      for (let i = 0; i < this._reportDefinition.Columns.length; i++) {
        filterValues[i] = this._filterValuesList[i] ? this._filterValuesList[i] : null;
      }
      this.calculateOptimalRows();
    }

    this._coreProxyService.ReportingService.ExecuteReport(
      this._appService.getAccessToken(),
      this._reportDefinition.ReportID,
      this._appService.getFacilityID(),
      this._params,
      filterValues,
      (reportHandle: string) => {
        this._reportHandle = reportHandle;
        
        if (this._reportDefinition.ReportType === CoreTypes.ReportType.Tabular) {
          this.movePage(0);
        }
        
        this._appService.stopLoading();
      },
      (exception) => {
        this._appService.stopLoading();
        this._appService.showException(exception);
      }
    );
  }

  private calculateOptimalRows(): void {
    if (this.reportResultContainer?.nativeElement) {
      const tableHead: HTMLElement = this.reportResultContainer.nativeElement.querySelector('thead');
      if (tableHead) {
        this._rowsNumber = Math.floor(
          (window.innerHeight - tableHead.getBoundingClientRect().top - tableHead.offsetHeight - 86) / 38
        ) - 2;
        this._rowsNumber = this._rowsNumber <= 10 ? 10 : this._rowsNumber;
      }
    }
  }

  movePage(value: number): void {
    let rowIndex = 0;
    
    if (value > 0) {
      rowIndex = this._currentPageNumber * this._rowsNumber;
    } else if (value < 0) {
      rowIndex = (this._currentPageNumber - 2) * this._rowsNumber;
      if (rowIndex < 0) {
        rowIndex = 0;
      }
    }

    this._coreProxyService.ReportingService.GetReportPage(
      this._appService.getAccessToken(),
      this._reportHandle,
      rowIndex,
      this._rowsNumber,
      (content: CoreTypes.ReportPageContent) => {
        this._reportDetails = content;
        this._cloneFilteredArray = JSON.parse(JSON.stringify(content));
        this._FilteredArray = content;
        
        this._NextHidden = rowIndex + this._rowsNumber >= content.RowCount;
        this._PreviousHidden = rowIndex <= 0;
        this._currentPageNumber = Math.floor(rowIndex / this._rowsNumber) + 1;
        this._firstTimeExecuted = true;
        this._totalRowCount = content.RowCount.toString();
        this._totalPageCount = Math.ceil(content.RowCount / this._rowsNumber);
      },
      (exception) => {
        this._appService.showException(exception);
      }
    );
  }

  resetParams(): void {
    this._params = JSON.parse(JSON.stringify(this.cloneParams));
    this.enableCleanFilter = false;
  }

  get selectedCount(): number {
    return this.selectedRowIds.size;
  }
  
  getRowId(row: any[], index: number): string {
    if (row && row[0] !== undefined && row[0] !== null) {
      return String(row[0]);
    }
    return `r-${this._currentPageNumber}-${index}`;
  }
  
  updateCurrentPageIds() {
    const rows = this._FilteredArray?.Rows || [];
    this.currentPageRowIds = rows.map((r, i) => this.getRowId(r, i));
    this.allSelected = this.currentPageRowIds.length > 0 &&
    this.currentPageRowIds.every(id => this.selectedRowIds.has(id));
  }
  
  toggleSelectAll(checked: boolean) {
    if (!this.currentPageRowIds?.length) { this.allSelected = false; return; }
    if (checked) {
      this.currentPageRowIds.forEach(id => this.selectedRowIds.add(id));
    } else {
      this.currentPageRowIds.forEach(id => this.selectedRowIds.delete(id));
    }
    this.allSelected = checked;
  }
  
  toggleRowSelectionById(id: string, checked: boolean) {
    if (!id) { return; }
    if (checked) { this.selectedRowIds.add(id); }
    else { this.selectedRowIds.delete(id); }
    this.allSelected = this.currentPageRowIds.length > 0 &&
                      this.currentPageRowIds.every(iid => this.selectedRowIds.has(iid));
  }
  
  getSelectedRows(): any[] {
    const allRows = this._cloneFilteredArray?.Rows || this._FilteredArray?.Rows || [];
    return allRows.filter((r, i) => this.selectedRowIds.has(this.getRowId(r, i)));
  }

  getStartRecord(): number {
    if (!this._totalRowCount || this._totalRowCount === '0') return 0;
    return (this._currentPageNumber - 1) * this._rowsNumber + 1;
  }

  getEndRecord(): number {
    if (!this._totalRowCount || this._totalRowCount === '0') return 0;
    const totalRecords = parseInt(this._totalRowCount);
    const endRecord = this._currentPageNumber * this._rowsNumber;
    return Math.min(endRecord, totalRecords);
  }

  getVisiblePages(): number[] {
    const pages: number[] = [];
    const totalPages = this._totalPageCount;
    const currentPage = this._currentPageNumber;
    const maxVisible = this.maxVisiblePages;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      let endPage = Math.min(totalPages, startPage + maxVisible - 1);

      if (endPage - startPage + 1 < maxVisible) {
        startPage = Math.max(1, endPage - maxVisible + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

  goToFirstPage(): void {
    if (this._currentPageNumber > 1) {
      this.goToPage(1);
    }
  }

  goToLastPage(): void {
    if (this._currentPageNumber < this._totalPageCount) {
      this.goToPage(this._totalPageCount);
    }
  }

  goToPage(pageNumber: number): void {
    if (pageNumber >= 1 && pageNumber <= this._totalPageCount && pageNumber !== this._currentPageNumber) {
      const rowIndex = (pageNumber - 1) * this._rowsNumber;
      this.loadPageData(rowIndex, pageNumber);
    }
  }

  jumpToPageNumber(): void {
    if (this.jumpToPage && this.jumpToPage >= 1 && this.jumpToPage <= this._totalPageCount) {
      this.goToPage(this.jumpToPage);
      this.jumpToPage = null; // Limpiar el input
    }
  }

  onPageSizeChange(): void {
    this._totalPageCount = Math.ceil(parseInt(this._totalRowCount) / this._rowsNumber);
    
    if (this._currentPageNumber > this._totalPageCount) {
      this._currentPageNumber = this._totalPageCount;
    }
    
    this.goToPage(this._currentPageNumber);
  }

  private loadPageData(rowIndex: number, pageNumber: number): void {
    this._coreProxyService.ReportingService.GetReportPage(
      this._appService.getAccessToken(),
      this._reportHandle,
      rowIndex,
      this._rowsNumber,
      (content: CoreTypes.ReportPageContent) => {
        this._reportDetails = content;
        this._cloneFilteredArray = JSON.parse(JSON.stringify(content));
        this._FilteredArray = content;
        
        this._NextHidden = rowIndex + this._rowsNumber >= content.RowCount;
        this._PreviousHidden = rowIndex <= 0;
        this._currentPageNumber = pageNumber;
        this._firstTimeExecuted = true;
        this._totalRowCount = content.RowCount.toString();
        this._totalPageCount = Math.ceil(content.RowCount / this._rowsNumber);
        this.updateCurrentPageIds();
      },
      (exception) => {
        this._appService.showException(exception);
      }
    );
  }

  dropdownMenuAction(event: any, item: LabelValue<number>): void {
    switch (item.value) {
      case 1:
        this.allSelected = true;
        this.toggleSelectAll(true);
        break;
      case 2:
        this.allSelected = false;
        this.toggleSelectAll(false);
        break;
      default:
        break;
    }
  }
  search(event: any): void {
    console.log('search', event);
  }

  getSectorsList(): Observable<any> {
    return new Observable(observer => {
      this.apolusProxyService.ApolusService.EnumSectors(
        this._appService.getAccessToken(),
        (data: ApolusTypes.Sector[]) => {
          let items: LabelValue<number>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.Description,
              value: x.SectorID
            };
            items.push(item);
          });
          this.sectorList = items;
          this.sector = this.sectorList[0];
          observer.next(true);
          observer.complete();
        },
        (err) => {
          this._appService.showException(err);
          observer.error(err);
        }
      );
    });
  }

  getAddressesList(): Observable<any> {
    return new Observable(observer => {
      this.apolusProxyService.ApolusService.EnumGeocodingAddresses(
        this._appService.getAccessToken(),
        (data: ApolusTypes.GeocodingAddress[]) => {
          let items: LabelValue<number>[] = [];
          let addresses: LabelValue<number>[] = [];
          let streetNumbers: LabelValue<string>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.StreetName + ' ' + x.StreetNumber,
              value: x.AdminArea2ID
            };
            let address = {
              label: x.StreetName,
              value: x.AdminArea2ID
            };
            let streetNumber = {
              label: x.StreetNumber,
              value: x.StreetNumber
            };
            streetNumbers.push(streetNumber);
            addresses.push(address);
            items.push(item);
          });
          this.localityList = items;
          this.locality = this.localityList[0];
          this.addressList = addresses;
          this.address = this.addressList[0];
          this.streetNumberList = streetNumbers;
          this.streetNumber = this.streetNumberList[0];
          observer.complete();
        },
        (err) => {
          this._appService.showException(err);
          observer.error(err);
        }
      );
    });
  }

  showMoreFilters() {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }

  onDateSelectChange(event: any) {

  }
}
